<template>
  <div>
    <div class="header">
      <span style="font-weight: 600; font-size: 14px; color: #333333"
        >自动规则</span
      >
      <span style="margin-left: 12px; color: #666">{{ row.campaignName }}</span>
    </div>
    <div class="content">
      <gj-button
        type="primary"
        @click="handleAdd"
        v-if="$permission('adsStrategyTemplate:add')"
        >新增自动规则</gj-button
      >
      <div style="height: 260px; margin-top: 12px">
        <gj-table
          ref="gjTable"
          :index="false"
          :data="tableData"
          adaptParent
          :loading="loading"
          :columns="adEntry === false ? tableColumns : tableColumns1"
          :show-overflow="false"
        >
          <template #name="{ row }">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="margin-right: 4px">{{ row.name }}</div>
              <el-tag size="mini" type="info" style="color: #666; border: none">{{
                row.templateDetailVO.type === "template" ? "模板" : "非模板"
              }}</el-tag>
            </div>
          </template>
          <template #stateMap="{ row }">
            <gj-switch
              size="small"
              @input="handleSwitch($event, row, false)"
              :value="row.stateVal"
              :active-text="row.stateMap"
            ></gj-switch>
          </template>
          <template #applyObjectAdsType="{ row }">
            <div>
              <div
                style="margin-bottom: 4px; color: #1f6eef; cursor: pointer"
                @click="pushApply(row)"
              >
                {{ row.applyObjectName | defaultShow }}
              </div>
              <el-tag
                size="mini"
                type="info"
                style="margin-right: 10px"
                v-if="row.applyObjectAdsType"
                >{{ optionMap[row.applyObjectAdsType] }}</el-tag
              >
              <el-tag size="mini" type="success" v-if="row.adsStatus === 1">{{
                row.adsStatus === 1 ? "活跃" : "不活跃"
              }}</el-tag>
              <gj-popover v-else trigger="hover">
                <template slot="reference">
                  <el-tag size="mini" type="danger"
                    >{{ row.adsStatus === 1 ? "活跃" : "不活跃" }}
                    <i class="el-icon-arrow-down"></i>
                  </el-tag>
                </template>
                <div class="ad-status">
                  <span>广告活动</span>
                  <span
                    :style="{
                      color: row.campaignState === 0 ? '#333333' : '#F5222D',
                    }"
                    >{{ row.campaignState === 0 ? "启动中" : "暂停中" }}</span
                  >
                </div>
                <div
                  class="ad-status"
                  v-if="row.applyObjectAdsType !== 'campaign'"
                >
                  <span>广告组</span>
                  <span
                    :style="{
                      color: row.groupState === 0 ? '#333333' : '#F5222D',
                    }"
                    >{{ row.groupState === 0 ? "启动中" : "暂停中" }}</span
                  >
                </div>
                <div
                  class="ad-status"
                  v-if="
                    row.applyObjectAdsType !== 'campaign' &&
                    row.applyObjectAdsType !== 'group'
                  "
                >
                  <span>投放</span>
                  <span
                    :style="{ color: row.state === 0 ? '#333333' : '#F5222D' }"
                    >{{ row.state === 0 ? "启动中" : "暂停中" }}</span
                  >
                </div>
              </gj-popover>
            </div>
          </template>
          <template #op="{ row }">
            <gj-button
              type="text"
              @click="handleRemove(row)"
              v-if="$permission('adsStrategyObject:delete')"
              >移除</gj-button
            >
            <gj-button
              type="text"
              @click="handleEdit(row)"
              v-if="$permission('adsStrategyTemplate:update')"
              >编辑</gj-button
            >
          </template>
        </gj-table>
      </div>
    </div>
  </div>
</template>

<script>
import { queryRuleDetail, batchRule } from "@/api/ad";
import { state, objectAdsType } from "./config";
import { getRuleContent, optionMap } from "../const";
import _ from "lodash";
export default {
  name: "ErpWebAutoRule",
  inject: ["removeTab", "getNavTabs"],
  props: {
    row: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
    },
    isAdd: {
      type: Boolean,
      default: true,
    },
    autoRuleData: {
      type: Array,
      default: () => [],
    },
    adEntry: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionMap,
      stateValMap: {
        enabled: true,
        paused: false,
      },
      tableData: [],
      tableColumns: [
        {
          id: "name",
          header: "自动规则名称",
          field: "slot:name",
          width: "200px",
        },
        {
          id: "applyObjectAdsTypeMap",
          header: "优化对象",
          field: "applyObjectAdsTypeMap",
          width: "100px",
        },
        {
          id: "ruleText",
          header: "规则详情",
          field: "ruleText",
          width: "300px",
        },
        {
          id: "lastExecuteDate",
          header: "最新执行时间",
          field: "lastExecuteDate",
          width: "100px",
        },
        {
          id: "stateMap",
          header: "规则启用状态",
          field: "slot:stateMap",
          width: "120px",
        },
        { id: "op", header: "操作", field: "slot:op", width: "90px" },
      ],
      tableColumns1: [
        {
          id: "applyObjectAdsType",
          header: "应用对象",
          field: "slot:applyObjectAdsType",
          width: "180px",
        },
        {
          id: "name",
          header: "自动规则名称",
          field: "slot:name",
          width: "200px",
        },
        {
          id: "ruleText",
          header: "规则详情",
          field: "ruleText",
          width: "300px",
        },
        {
          id: "lastExecuteDate",
          header: "最新执行时间",
          field: "lastExecuteDate",
          width: "100px",
        },
        {
          id: "stateMap",
          header: "规则启用状态",
          field: "slot:stateMap",
          width: "120px",
        },
        { id: "op", header: "操作", field: "slot:op", width: "90px" },
      ],
      loading: false,
    };
  },
  watch: {
    autoRuleData(val) {
      this.tableData = val;
    },
  },
  methods: {
    // 路由跳转前处理
    handleRouter(callback, name) {
      const tabs = this.getNavTabs();
      if (tabs.some((item) => item.name === name)) {
        this.removeTab(name);
        callback();
      } else {
        callback();
      }
    },
    async query() {
      let data = [];
      this.loading = true;
      const params = {
        marketId: this.row.marketId,
        applyObjectId: this.row.objectId,
        applyObjectAdsType: this.row.objectType,
      };
      await queryRuleDetail(params)
        .then((res) => {
          res.forEach((el) => {
            el.name = el.templateDetailVO.name;
            el.stateMap = state[el.state];
            el.stateVal = this.stateValMap[el.state];
            el.applyObjectAdsTypeMap =
              objectAdsType[
                el.templateDetailVO.expressionVO.executeObjectAdsType
              ];
            el.ruleText = getRuleContent(el.templateDetailVO.expressionVO);
          });
          this.tableData = res;
          data = res;
        })
        .finally(() => {
          this.loading = false;
        });
      return data;
    },
    handleAdd() {
      const extra = [
        {
          marketId: this.row.marketId,
          adsType: this.row.adType,
          campaignId: this.row.campaignId,
          applyObjectId: this.row.objectId,
          applyObjectName: this.row.objectName,
          applyObjectAdsType: this.row.objectType,
        },
      ];
      this.handleRouter(() => {
        this.$router.push({
          path: `/ad/add-rule-template`,
          query: {
            type: "add",
            belong: "rule",
            sourceRoute: this.$route.path,
            extra: JSON.stringify(extra),
          },
        });
      }, "新增自动模板规则");
    },
    handleRemove(row) {
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          title: "操作确认",
          content: `确认移除自动规则，是否继续？`,
        },
        on: {
          cancel: () => {
            modal.$gjDestroy();
          },
          confirm: () => {
            callback();
          },
        },
      });
      const callback = () => {
        const params = [
          {
            marketId: row.marketId,
            id: row.objectPrimaryId,
            state: "archived",
          },
        ];
        batchRule(params)
          .then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              this.query().then(() => {
                this.$emit("update", this.tableData, this.index);
              });
            } else {
              this.$message.error(res.msg);
            }
          })
          .finally(() => {
            modal.$gjDestroy();
          });
      };
    },
    handleEdit(row) {
      const extra = [
        {
          marketId: this.row.marketId,
          adsType: this.row.adType,
          campaignId: this.row.campaignId,
          applyObjectId: this.row.objectId,
          applyObjectName: this.row.objectName,
          applyObjectAdsType: this.row.objectType,
        },
      ];
      this.handleRouter(() => {
        this.$router.push({
          path: `/ad/add-rule-template/edit`,
          query: {
            id: row.templateDetailVO.id,
            type: "edit",
            belong: "rule",
            sourceRoute: this.$route.path,
            extra: JSON.stringify(extra),
            objectPrimaryId: row.objectPrimaryId,
            templateDetailVOType: row.templateDetailVO.type,
          },
        });
      }, "编辑自动规则");
    },
    handleSwitch: _.debounce(function (e, row, affirm = true) {
      let modal = null;

      const callback = () => {
        const params = [
          {
            marketId: row.marketId,
            id: row.objectPrimaryId,
            state: e ? "enabled" : "paused",
          },
        ];
        batchRule(params)
          .then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              this.query();
            } else {
              this.$message.error(res.msg);
            }
          })
          .finally(() => {
            modal && modal.$gjDestroy();
          });
      };
      if (affirm) {
        modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: "操作确认",
            content: `确认操作自动规则，是否继续？`,
          },
          on: {
            cancel: () => {
             modal && modal.$gjDestroy();
            },
            confirm: () => {
              callback();
            },
          },
        });
      } else {
        callback();
      }
    }, 200),
    pushApply(row) {
      const extra = {
        marketId: row.marketId,
        objectType: row.applyObjectAdsType,
        campaignId: row.campaignId,
        groupId: row.applyObjectAdsType === "group" ? row.applyObjectId : null,
        applyObjectName: row.applyObjectName,
      };
      this.handleRouter(() => {
        this.$router.push({
          path: `/ad/ad-automate`,
          query: {
            type: row.applyObjectAdsType,
            sourceRoute: this.$route.path,
            extra: JSON.stringify(extra),
          },
        });
      }, "广告自动化");
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  border-bottom: 1px solid #e4e5e6;
}
.content {
  padding: 12px 20px 20px 20px;
}

.ad-status {
  color: #333333;
  display: flex;
  justify-content: space-between;
}
.ad-status + .ad-status {
  margin-top: 8px;
}
</style>
